import { queryOptions } from "@tanstack/react-query";
import {
  listBarangays,
  listCities,
  listCountries,
  listRegions,
} from "#/server/functions/addresses";

const STALE = 60 * 60 * 1000; // geo reference data is effectively immutable

export const addressKeys = {
  all: ["addresses"] as const,
  countries: ["addresses", "countries"] as const,
  regions: (countryCode: string | null) =>
    ["addresses", "regions", countryCode] as const,
  cities: (regionId: string | null) =>
    ["addresses", "cities", regionId] as const,
  barangays: (cityId: string | null) =>
    ["addresses", "barangays", cityId] as const,
};

export const addressQueries = {
  countries: () =>
    queryOptions({
      queryKey: addressKeys.countries,
      queryFn: () => listCountries(),
      staleTime: STALE,
    }),
  regions: (countryCode: string | null) =>
    queryOptions({
      queryKey: addressKeys.regions(countryCode),
      queryFn: () =>
        countryCode ? listRegions({ data: { countryCode } }) : [],
      enabled: countryCode != null && countryCode.length >= 2,
      staleTime: STALE,
    }),
  cities: (regionId: string | null) =>
    queryOptions({
      queryKey: addressKeys.cities(regionId),
      queryFn: () => (regionId ? listCities({ data: { regionId } }) : []),
      enabled: regionId != null && regionId.length > 0,
      staleTime: STALE,
    }),
  barangays: (cityId: string | null) =>
    queryOptions({
      queryKey: addressKeys.barangays(cityId),
      queryFn: () => (cityId ? listBarangays({ data: { cityId } }) : []),
      enabled: cityId != null && cityId.length > 0,
      staleTime: STALE,
    }),
};
